module.exports = __webpack_public_path__ + "assets/img/33bb-dk.svg";